import * as Sentry from '@sentry/vue'
/**
 * @module
 * @name Timedout
 */
export default {
  name: 'Timedout',
  mounted() {
    localStorage.clear()
    sessionStorage.clear()

    // Send sentry custom event
    const scope = new Sentry.Scope()
    scope.setTag('section', 'OTP timedout')
    scope.setContext({
      timedOut: timedOut
    })
    Sentry.captureException(new Error('Error link expired'), () => scope)
  }
}
